import React from 'react';
import Store from 'store/store';
import FileUploadComponent from '../FileUpload/FileUploadComponent';
const { selectors } = Store;
import actions from 'store/actions';
import { connect } from 'react-redux';
import Palette from '../Palette/Palette';
import { useTheme } from '@material-ui/core/styles';
import { paletteSettings } from '../Palette/utils';
import { Grid } from '@material-ui/core';
import { BoxWrapper } from 'components/Base';
import { get } from 'lodash';

const Branding = ({
  firmLogo,
  firmCoverImage,
  setFirmConfig,
  isFirmAdmin,
  riskProfiler
}: any) => {
  const theme = useTheme() as any;
  const palettes = paletteSettings(theme, riskProfiler);

  const getDefaultColors = (key: string) => {
    if (key === 'theme') {
      return [theme.palette.primary.main, theme.palette.secondary.main];
    }
    return key
      ? theme.palette.baseColors.charts[key]
      : theme.palette.baseColors.charts['default'];
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      <FileUploadComponent
        title="Firm Logo"
        fieldName="document_logo"
        buttonLabel="Upload logo"
        initialFile={firmLogo}
        setFirmConfig={setFirmConfig}
        isFirmAdmin={isFirmAdmin}
        subTitle="Upload your firm's logo as a PNG file with a transparent background (if possible). This logo will appear in all reports."
      />
      <FileUploadComponent
        title="Cover Image"
        fieldName="cover_image"
        buttonLabel="Upload cover image"
        initialFile={firmCoverImage}
        setFirmConfig={setFirmConfig}
        isFirmAdmin={isFirmAdmin}
        subTitle="Upload a high-resolution cover image that adds a personalised touch to your reports. For best results, use a PNG image with a width greater than 1000px and keep essential details away from the edges to avoid cropping."
      />
      <BoxWrapper
        title={'Brand Colours'}
        subTitle="Customise colours for buttons, headings, charts and graphs. Choose
          colours that reflect your brand’s style, enhancing the user experience
          and maintaining brand consistency throughout reports and visuals."
      >
        <Grid container spacing={2} alignItems="stretch">
          {palettes
            .filter(item => get(item, 'visible', true))
            .map(({ title, subTitle, key, maxColours }) => (
              <Grid item xs={12} lg={6} key={key}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >
                  <Palette
                    title={title}
                    subTitle={subTitle}
                    fieldName={key}
                    defaultColors={getDefaultColors(key)}
                    {...(maxColours && { maxColours })}
                    isFirmAdmin={isFirmAdmin}
                  />
                </div>
              </Grid>
            ))}
        </Grid>
      </BoxWrapper>
    </div>
  );
};

export default connect(
  (state: any) => ({
    firmLogo: selectors.firmSelectors.documentUrl(state),
    firmCoverImage: selectors.firmSelectors.coverImageUrl(state),
    riskProfiler: selectors.firmSelectors.riskProfiler(state)
  }),
  {
    setFirmConfig: actions.firmActions.setFirmConfig
  }
)(Branding);
